import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Table } from 'antd';
import classNames from 'classnames/bind';
import Enum from 'utils/EnumsManager';
import { toTimezone } from 'utils/dateTimeUtils';
import { Panel } from 'components/ui/index';
import { fetchImportHistory } from '../flow/action';
import styles from '../index.less';

const cx = classNames.bind(styles);

class FileImportHistory extends React.Component {
  componentDidMount() {
    const { fetchImportHistory, pagination } = this.props;
    const { per_page, current_page } = pagination;
    fetchImportHistory(per_page, current_page);
  }

  handlePageChange = (page, pageSize) => {
    const { fetchImportHistory } = this.props;
    fetchImportHistory(pageSize, page);
  }

  renderColumns = () => {
    return (
      [
        {
          title: <FormattedMessage id="page.ObjectImport.importRequestId" />,
          dataIndex: 'receipt_no',
          key: 'receipt_no',
          width: 150
        },
        {
          title: <FormattedMessage id="page.ObjectImport.objectType" />,
          dataIndex: 'object_type',
          key: 'object_type',
          width: 80
        },
        {
          title: <FormattedMessage id="page.ObjectImport.importDate" />,
          dataIndex: 'created_at',
          key: 'created_at',
          render: text => toTimezone(text, true),
          width: 150
        },
        {
          title: <FormattedMessage id="page.ObjectImport.information" />,
          dataIndex: 'error',
          key: 'error',

        },
        {
          title: <FormattedMessage id="page.ObjectImport.importedBy" />,
          dataIndex: 'user_name',
          key: 'user_name',
          width: 90
        },
        {
          title: <FormattedMessage id="page.ObjectImport.status" />,
          dataIndex: 'status',
          key: 'status',
          render: (text, record) => {
            let statusType = '';

            switch (text) {
              case 'succeeded':
                statusType = 'status-success';
                break;

              case 'failed':
                statusType = 'status-failed';
                break;

              case 'queueing':
              case 'processing':
                statusType = 'status-processing';
                break;

              default:
                break;
            }
            return (<span className={cx('history-status', statusType)}>{text}</span>);
          }
        },
      ]
    );
  }

  render() {
    const { pagination, importHistoryData } = this.props;
    const { current_page, per_page, total } = pagination;
    const tablePagination = {
      current: current_page,
      pageSize: per_page,
      total,
      onChange: this.handlePageChange
    };

    return (
      <Panel
        panelTitle={<FormattedMessage id="page.ObjectImport.importHistory" />}
      >
        <Table
          className="pl-lg pr-lg none-border-table"
          columns={this.renderColumns()}
          dataSource={importHistoryData}
          rowKey={record => record.id}
          pagination={tablePagination}
          size="small"
        />
      </Panel>
    );
  }
}

const mapStateToProps = ({ global, setup }) => ({
  lang: global.language,
  pagination: setup.fileImport.pagination,
  importHistoryData: setup.fileImport.importHistoryData,
});

const mapDispatchToProps = {
  fetchImportHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(FileImportHistory);



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectImport/component/FileImportHistory.jsx